import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Bootstrap 4 + Argon theme (grid/utilities used everywhere)
import './assets/scss/argon-dashboard-react.scss';
// Font Awesome moved into lazy chunks: full set in App, subset in publicApp
import './i18n';
import './assets/css/ocean-theme.css';
import { applyUiSkin } from './utils/uiTheme';

applyUiSkin();

// Lazy-load both apps so the landing page doesn't pull in admin code and vice versa
const App = React.lazy(() => import(/* webpackChunkName: "admin-app" */ './App'));
const PublicApp = React.lazy(() => import(/* webpackChunkName: "public-app" */ './publicApp'));

const isApp = window.location.pathname.startsWith('/app');

const mountNode = document.getElementById('root') as HTMLElement | null;
if (mountNode) {
  const root = ReactDOM.createRoot(mountNode);
  root.render(
    <React.StrictMode>
      <Suspense fallback={null}>
        {isApp ? <App /> : <PublicApp />}
      </Suspense>
    </React.StrictMode>
  );
}
